import React from 'react';
import { Progress } from 'antd';
interface BarraProps {
    percentual: string;
    strokeColor: string;
}

const Barra = (props: BarraProps) => {
    const { percentual, strokeColor } = props;

    const valorBarra = (valor: number) => {

        if (valor < 100) {
            return valor;
        } else {
            if (valor > 200) {
                return valor / 3;
            } else {
                return valor / 2;
            }
        }
    }
    return (<Progress percent={valorBarra(parseInt(percentual))} showInfo={false} strokeColor={strokeColor} />);
}
export default Barra;





